<template>
  <div class="page wallet">
    <pageTitle title='添加银行卡' />
    <inputBox hintMsg='卡号' label='卡号' v-model='number' />
    <inputBox hintMsg='卡背面三位' label='CVN2' v-model='cvn2' extendType='icon' :extendSrc="require('../../assets/svg/question.svg')" @extendHandler='open(1)'/>
    <inputBox hintMsg='有效月份' label='有效月' v-model='month' extendType='icon' :extendSrc="require('../../assets/svg/question.svg')" @extendHandler='open(0)'/>
    <inputBox hintMsg='有效年份' label='有效年' v-model='year' extendType='icon' :extendSrc="require('../../assets/svg/question.svg')" @extendHandler='open(0)'/>
    <inputBox hintMsg='银行预留手机号' label='手机号' v-model='mobilePhone' />
    <inputBox hintMsg='短信验证码' label='验证码' v-model='validCode' :extendLock='haveYZM' extendType='button' :extendSrc="haveYZM?WaitTime:'获取验证码'" @extendHandler='getCode'/>
    <mu-raised-button label="确定" primary @click="post" v-bind:style="{ width:'96%',height:'50px',margin:'2%'}"/>
    <mu-dialog :open="dialog" @close="close">
      <div style="margin:-27px;">
        <img  v-bind:src="url" style="height:100%;width:100%" />
      </div>
    </mu-dialog>
    <mu-toast v-if="toast" id="alertline" v-bind:message="errMes" @close="hideToast"/>
  </div>
</template>
<style lang="less" scoped>
@import "../../assets/theme.less";
    .page{ 
        background-color:white;
        .form{
            margin-top:10px;
            div{
                position:relative;
                .amount{
                    color:black;
                }
                .tip{
                    position:absolute;
                    right:4%;
                    top:9px;
                }
            }
        }
        #payMsg{
            div{
                padding-top:5px;
                height:42px;
                input{
                    margin-bottom:0px;
                }
                .date{
                    width:3em;
                    text-align:left;
                }
                #get{
                     position:absolute;
                     width:170px;
                     top:0px;
                     right:-50px;
                     input{
                         background-color:@primaryColor;
                         color:white;
                     }
                }
            }
        }
    }
</style>

<script>
import api from '../../api'
import { mapGetters,mapMutations } from 'vuex'
import {} from  '../../utils/valid.js'
export default {
    data(){
        return{
            toast: false,
            dialog: false,
            url:'',
            errMes:'',
            number:'',
            cvn2:'',
            month:'',
            year:'',
            mobilePhone:'',
            validCode:'',
            haveYZM: false,
            WaitTime: '',
            Time: 29,
        }
    },
    methods: {
      ...mapMutations({
          changeAmountNumber:'setG_accountNumber'
      }),
      getCode(){
          if(this.number.trim() == ''){
              this.errMes='请填写卡号！';
              this.showToast();
              return
          }
          else if(this.mobilePhone.trim() == ''){
              this.errMes='请填写银行预留手机号码！';
              this.showToast();
              return
          }
          else{
                // 开始计时
                this.haveYZM = true;
                this.WaitTime = this.Time + "秒"
                this.timer();
                var params = new this.URLSearchParam();
                params.append('bankCard', this.number);
                params.append('phoneNo', this.mobilePhone);
                this.$http.post(api.getValidateCodeToBindCard(),params.toParam()).then((res) => {
                    if(res.Result){
                        this.errMes = '验证码已发送到您的手机上！';
                    }
                    else{
                        this.errMes = res.Message;
                       //this.$router.push({ path: '/user/Login' })
                        this.Time = 5;
                    }
                    this.showToast();
                })
          }
      },
      showToast () {
        this.toast = true
        if (this.toastTimer) clearTimeout(this.toastTimer)
        this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
      },
      hideToast () {
        this.toast = false
        if (this.toastTimer) clearTimeout(this.toastTimer)
      },
      open (pos) {
        if(pos == 0){
            this.url='../../../static/wallet/card_front.png';
        }
        else{
            this.url='../../../static/wallet/card_oppsite.png';
        }
        this.dialog = true
      },
      close () {
        this.dialog = false
      }, 
      post(e){
        e.preventDefault(); 
        if(this.valid()){ 
            var params = new this.URLSearchParam();
            params.append('accountCardNumber', this.number);
            params.append('CVN2', this.cvn2);
            params.append('expiryMonth', this.month);
            params.append('expiryYear', this.year);
            params.append('mobile', this.mobilePhone);
            params.append('smsVerificationCode', this.validCode);
            this.$http.post(api.confirmBindingCard(),params.toParam()).then((res) => {
                if(res.Result){
                    this.errMes = res.Data;
                    this.showToast();
                    this.$router.push({ path: '/wallet/myBankCards' })
                }
                else{
                    this.errMes = res.Message;
                    this.showToast();
                    //this.$router.push({ path: '/user/Login' })
                }
            })
        }
        else{
            this.showToast();
        }
      },
      valid(){
        if(this.number.trim()==''){
            this.errMes='请填写卡号！';
            return false;
        }
        if(this.cvn2.trim()==''){
            this.errMes='请填写CVN2！';
            return false;
        }
        if(this.month.trim()==''){
            this.errMes='请填写月份！';
            return false;
        }
        if(this.year.trim()==''){
            this.errMes='请填写年份！';
            return false;
        }
        if(this.mobilePhone.trim()==''){
            this.errMes='请填写手机号码！';
            return false;
        }
        if(this.validCode.trim()==''){
            this.errMes='请填写验证码！';
            return false;
        }
        else{
            return true;
        }
      },
      timer() {
        if (this.Time > 0) {
          this.Time--;
          this.WaitTime = this.Time + "秒"
          setTimeout(this.timer, 1000);
        }
        else if (this.Time == 0) {
          this.haveYZM = false;
          this.Time = 29;
        }
      },
    },
    computed:{
        ...mapGetters({
            numbers:'g_accountNumber',
        }),
    },
    activated(){
      this.number = '',
      this.cvn2 = '',
      this.month = '',
      this.year = '',
      this.mobilePhone = '',
      this.validCode = ''
    }
}    
</script>


// WEBPACK FOOTER //
// addBankCard.vue?5af79bb1